import {
  Badge,
  Box,
  Card,
  CardContent,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";
import {
  DocumentStatus,
  DocumentType,
  DocumentsData,
} from "../../../interfaces/document";
import moment from "moment";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaymentIcon from "@mui/icons-material/Euro";
import ElementGridDocument from "./ElementGridDocument";
import PersonIcon from "@mui/icons-material/Person";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import IconPorto from "@mui/icons-material/LocalShipping";
export const getStatus = (status: string) => {
  switch (status) {
    case DocumentStatus.OPEN:
      return "APERTO";
    case DocumentStatus.CLOSED:
      return "CHIUSO";
    case DocumentStatus.PENDING:
      return "ATTESA";
  }

  return "";
};

export const getDocumentType = (type: string) => {
  switch (type) {
    case DocumentType.ACCEPTANCE:
      return "ACCETT.";
    case DocumentType.DISPATCH:
      return "EVASIONE";
  }

  return "";
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case DocumentStatus.OPEN:
      return "success";
    case DocumentStatus.CLOSED:
      return "error";
    case DocumentStatus.PENDING:
      return "warning";
  }

  return "primary";
};
const documentCard = ({
  elements,
  onClick,
  sx,
  showAddress,
}: {
  elements: DocumentsData;
  onClick?: () => void;
  sx?: SxProps;
  showAddress?: boolean;
}) => {
  const fullAddress = (
    <Typography
      variant="body2"
      sx={{ textAlign: { xs: "center", md: "right" } }}
    >
      {elements?.address} <br />
      {elements?.city} ({elements?.province})<br /> {elements?.postalCode},{" "}
      {elements?.country}
      {elements?.phoneNumber && (
        <>
          <br />
          TEL {elements?.phoneNumber}
        </>
      )}
    </Typography>
  );
  return (
    <Card
      sx={{
        ...sx,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        position: "relative",
      }}
      onClick={(e) => (onClick ? onClick() : "")}
    >
      <CardContent sx={{ padding: "15px" }}>
        {elements?.carriageDescription && (
          <ElementGridDocument
            description={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "darkcyan",
                  my: 1,
                }}
              >
                <IconPorto />
                {elements?.carriageDescription}
              </Box>
            }
          />
        )}
        {elements?.customerDisplayName && (
          <ElementGridDocument
            title={`CLIENTE`}
            description={`${elements?.customerDisplayName ?? ""}`}
            Icon={PersonIcon}
            divider
          />
        )}
        {elements?.destinationDisplayName && (
          <ElementGridDocument
            title={"DESTINATARIO"}
            description={
              <>
                {elements?.destinationDisplayName}{" "}
                {showAddress && (
                  <>
                    <br />
                    {fullAddress}
                  </>
                )}
              </>
            }
            Icon={AccountCircleIcon}
            divider
          />
        )}
        <ElementGridDocument
          title={"DOCUMENTO"}
          description={elements?.externalDocument ?? ""}
          Icon={ReceiptIcon}
          divider
        />
        {elements.type === DocumentType.DISPATCH && elements?.shipmentCost ? (
          <ElementGridDocument
            title={"SPEDIZIONE"}
            description={`€ ${elements?.shipmentCost?.toFixed(2)}`}
            Icon={PaymentIcon}
            divider
          />
        ) : null}
        <ElementGridDocument
          title={`${elements?.products?.length ?? "0"} PRODOTT${
            elements?.products?.length === 1 ? "O" : "I"
          }`}
          Icon={ShoppingCartIcon}
          divider={showAddress}
        />
      </CardContent>
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        spacing={2}
        sx={{ p: 2 }}
      >
        <Stack alignItems="center" direction="row" spacing={1}>
          <Typography
            color="text.secondary"
            display="inline"
            variant="body2"
            fontSize={15}
          >
            {getDocumentType(elements?.type)} #{elements?.id}
          </Typography>
        </Stack>
        <Stack alignItems="center" direction="row" spacing={1}>
          <Badge
            sx={{ marginRight: 2 }}
            color={getStatusColor(elements?.status)}
            badgeContent={getStatus(elements?.status)}
          />
        </Stack>
        <Stack alignItems="center" direction="row" spacing={1}>
          <Typography color="text.secondary" display="inline" variant="body2">
            {moment(elements?.date).format("DD/MM/YYYY")}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

export default documentCard;
